module.exports = __webpack_public_path__ + "img/4.451950af.png";